"use client"
import { ADMIN_API_CONFIG } from "@/constants/api-configs"
import Image from "next/image"

interface PopupContactProps {
  isVN: boolean
}

const PopupContact = ({ isVN }: PopupContactProps) => {
  return (
    <div className="relative">
      <a
        href={isVN ? "https://zalo.me/0982090682" : "https://wa.me/+84937788990"}
        target="_blank"
        className={`fixed bottom-5 right-5 w-10 h-10 rounded-full shadow-2xl flex items-center justify-center bg-transparent
  transition-all duration-300 ease-in-out z-50 hover:scale-110 hover:shadow-none  "opacity-100 pointer-events-auto"
  `}
        aria-label="Scroll to top"
      >
        <Image
          src={`${ADMIN_API_CONFIG.API_URL}${
            isVN ? "/uploads/zalo_icon_4325e22af2.png" : "/uploads/whatsapp_icon_3140b44cf5.png"
          }`}
          alt="Contact icon"
          width={40}
          height={40}
          className="w-10 h-10 rounded-full"
        />
      </a>
    </div>
  )
}

export default PopupContact
